package com.cybersoftsolution.cybersoftsolutionweb.components.navigation

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.navigation.Screen
import com.cybersoftsolution.cybersoftsolutionweb.navigation.navigateTo
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.logout
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.core.PageContext

@Composable
fun AdminNavigationItems(context: PageContext){

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .overflow(Overflow.Auto)
            .scrollBehavior(ScrollBehavior.Smooth)
    ) {
        NavigationItem(
            selected = context.route.slug.equals(Screen.AdminHome.slug),
            title = "Inicio",
            icon = Resources.PathIconsVectors.home_ico,
            onClick = {
                context.navigateTo(Screen.AdminHome)
            }

        )
        NavigationItem(
            selected = context.route.slug.equals(Screen.AdminCreate.slug),
            title = "Nueva Publicación",
            icon = Resources.PathIconsVectors.add_ico,
            onClick = {
                context.navigateTo(Screen.AdminCreate)
            }

        )
        NavigationItem(
            selected = context.route.slug.equals(Screen.AdminPosts.slug),
            title = "Publicaciones",
            icon = Resources.PathIconsVectors.list_ico,
            onClick = {
                context.navigateTo(Screen.AdminPosts)
            }

        )
        NavigationItem(
            title = "Cerrar Sesión",
            icon = Resources.PathIconsVectors.logOut_ico,
            onClick = {
                logout()
                context.navigateTo(Screen.AdminLogin)
            }

        )
    }



}